module.exports = __webpack_public_path__ + "static/media/img93_R.778617ca.jpg";